module.exports = __webpack_public_path__ + "img/chevron-left.58d510d0.svg";